import { NgModule }  from '@angular/core';
import {
	RouterModule,
	Routes
}                    from '@angular/router';
import { AuthGuard } from '@app/core/guards/auth.guard';

const appRoutes: Routes = [
	{
		path: '',
		loadChildren: () => import('@layout/full-layout/full-layout.module').then( m => m.FullLayoutModule ),
		canActivate: [ AuthGuard ]
	}
];

@NgModule( {
	imports: [ RouterModule.forRoot( appRoutes, { enableTracing: false } ) ],
	exports: [ RouterModule ]
} )

export class AppRoutingModule {}
